export const selectUploadInProgress = (state) => state.fileUploadInProgress?.uploadInProgress;

export const selectNavigateTo = (state) => state.fileUploadInProgress?.navigateTo;
